export default "__VITE_ASSET__Bxxw5A_q__"